import { render, staticRenderFns } from "./DecisionAid.vue?vue&type=template&id=49bb7c6a&scoped=true"
import script from "./DecisionAid.vue?vue&type=script&lang=js"
export * from "./DecisionAid.vue?vue&type=script&lang=js"
import style0 from "./DecisionAid.vue?vue&type=style&index=0&id=49bb7c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb7c6a",
  null
  
)

export default component.exports